import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {sdoNs} from '../constants-enumerate';
/**
 * @summary LeftPanel
 * @extends {AoflElement}
 */
@customElement('left-panel')
class LeftPanel extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of LeftPanel.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'left-panel';

  @property({type: Boolean, attribute: false})
  offCanvas = false;

  @property({type: Boolean, attribute: false})
  menuExists = false;

  @property({type: Boolean, attribute: false})
  showOverlay = false;

  mapStateProperties() {
    const state = this.storeInstance.getState();
    this.showOverlay = state[sdoNs.SIDE_PANELS].$overlay;
    this.offCanvas = state.sidePanels.left.offCanvas;
    if (!state[sdoNs.LAYOUT].showMenu) {
      this.style.display = 'none';
    } else {
      this.style.display = '';
    }
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default LeftPanel;
